export const common = {
    login: 'ログイン',
    welcome: 'ようこそ',
    signOut: 'ログアウト',
    faq: 'よくある質問',
    pleaseSelect: 'リクエストIDを選択',
    noData: 'データなし',
    unsort: 'ソート解除',
    filters: 'フィルタ',
    filter: 'フィルタ',
    apply: '適用する',
    clearAll: 'すべてクリア',
    showAll: '全件表示',
    confirmModalTitle: '確認',
    yes: 'はい',
    no: 'いいえ',
    selectAll: '全て選択',
    xItemSelected: '件 選択済み',
    allSelected: '全て選択済み',
    relevent: 'リスクあり',
    Inrelevent: 'リスクなし',
    operatingManual: '取扱説明書',
    cancel: '取消',
    send: '提出',
    warningMsg: {
        inputRequired: '入力してください。',
        selectRequired: '選択してください。',
        invalidEmail: '無効なメールアドレス。'
    },

    company: '企業',
    theme: 'テーマ',
    country: '国',
    pageTitle: 'Intelligent Business Analytics',
    filterCompany: '企業を選択',
    filterTheme: 'テーマを選択',
    relatedTheme: '関連テーマ',
    filterCountry: '国を選択',
    filterCategory: 'カテゴリーを選択',
    search: '検索',
    selectLang: '日本語',

    // ヘッダーのモード切替
    userMode: 'ユーザーモード',
    adminMode: '管理者モード',
    analysisMode: 'コンサル分析アップロード',

    // ヘッダーのヘルプメニュー
    aboutTheService: 'サービスについて',
    howToUse: '使い方',
    glossary: '用語集',

    // request/index.js
    doubleLogin:
        '二重ログインを検知しましたので、強制ログアウトします。心当たりがない場合は早急に管理者へご連絡ください。'
}
